<template>
  <div>
    <v-row dense align="center">
      <v-col cols="12" sm="9" class="text-truncate">
        <px-situacao-cotacao-icon :situacao="cotacao.situacao"/>
        {{ cotacao.identificador }}
      </v-col>
      <v-col cols="12" sm="3" class="text-right">
        <v-menu :close-on-content-click="false" v-if="hasRoleComprador">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <px-cancelar-dialog
              texto-botao="Cancelar cotação"
              :titulo="getTitulo"
              :descricao="getDescricao"
              @cancelar-dialog="onClickCancelar"
              :disabled="!isAberta"/>
            <v-list-item :disabled="!isAberta"
                @click="onClickEdit">
              <v-list-item-icon>
                <v-icon>mdi-pencil</v-icon>
              </v-list-item-icon>
              <v-list-item-content>Editar cotação</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-icon>mdi-domain</v-icon>
        {{ cotacao.comprador.pessoa.nome }} ({{ cotacao.comprador.pessoa.cnpj | cpfCnpj }})
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-icon>mdi-map-marker</v-icon>
        {{ cotacao.comprador.endereco | endereco }}
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
            <v-icon>mdi-calendar</v-icon>
              {{ cotacao.createdIn | date(true) }}
            </span>
          </template>
          <span>Data de criação da Cotação</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoCotacao } from 'px-business-components';
import CotacaoService from '@/modules/cotacao/cotacao-service';

export default {
  props: {
    cotacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao
      || SituacaoCotacao.keys.EM_ANDAMENTO.key === this.cotacao.situacao;
    },
    getTitulo() {
      return 'Cancelar cotação';
    },
    getDescricao() {
      return `A cotação "${this.cotacao.identificador}" será cancelada e não poderá mais receber respostas.<br/>Esta operação não pode ser desfeita.`;
    },
  },
  methods: {
    onClickCancelar(motivoRecusa) {
      CotacaoService.cancelar(this.cotacao.id, { motivoRecusa })
        .then(() => {
          this.$emit('movimentada', this.cotacao);
          this.$toast('Cotação cancelada com sucesso', { color: 'success' });
        });
    },
    onClickEdit() {
      this.$router.push({ name: 'main.cotacoes.edicao-parcial' });
    },
  },
};
</script>
